export const SHOW_ALL_ACTIVITIES = "SHOW_ALL_ACTIVITIES";
export const SHOW_FLEX_RATES_MODAL = "SHOW_FLEX_RATES_MODAL";
